/**
 * 权限相关辅助函数
 * @description 从 userStore 抽取的权限生成逻辑
 */

import { PERMISSION_GROUPS, PERMISSIONS } from '@/constants'
import { UserRole } from '@/types/auth'

/**
 * 获取角色降级权限
 * @description 当 PermissionCore 失败时使用的回退权限
 * @param role 用户角色
 * @returns 基础权限数组
 */
export function getFallbackPermissions(role: UserRole): string[] {
  switch (role) {
    case UserRole.ADMIN:
      return [PERMISSIONS.WILDCARD]
    case UserRole.DESIGNER:
      return [
        ...PERMISSION_GROUPS.COMMON,
        ...PERMISSION_GROUPS.USER_BASE,
        ...PERMISSION_GROUPS.CERTIFIED,
        ...PERMISSION_GROUPS.DESIGNER_EXCLUSIVE,
      ]
    case UserRole.MANUFACTURER:
      return [
        ...PERMISSION_GROUPS.COMMON,
        ...PERMISSION_GROUPS.USER_BASE,
        ...PERMISSION_GROUPS.CERTIFIED,
        ...PERMISSION_GROUPS.MANUFACTURER_EXCLUSIVE,
      ]
    case UserRole.USER:
      return [
        ...PERMISSION_GROUPS.COMMON,
        ...PERMISSION_GROUPS.USER_BASE,
      ]
    case UserRole.GUEST:
    default:
      return []
  }
}
